import React from "react"

import {FieldEditableValueNotEmptyProps} from "../../../../../proto/components/editable/value-not-empty"
import {FieldViewSize} from "../../../../../const"

const debug = false
// const debug = "FieldGoalType_ValueNotEmpty"

export default function FieldGoalType_ValueNotEmpty(props:FieldEditableValueNotEmptyProps) {

    debug && console.log(debug, 'render', props)

    const {option}  = props

    const size      = _.get(props, 'size', FieldViewSize.DEFAULT)

    const valueClasses = Classes("ui5-field-dropdown-inline-editable", props.className)

    const labelClasses = Classes("txt-truncate", props.className, {
        'ui5-txt-default'               : size === FieldViewSize.DEFAULT,
        'ui5-txt-less-important-small'  : size === FieldViewSize.SMALL
    })

    debug && console.log(debug, 'render showIcon', option)

    return (
        <React.Fragment>
            <div className={valueClasses} onClick={props.onClick}>
                <div className={Classes('ui5-ico-14 m-r-5', option.icon)}/>
                <div className={labelClasses}>{option.label}</div>
            </div>
            {props.children}
        </React.Fragment>
    )
}
